module.exports = __webpack_public_path__ + "images/ac9453cda349097cf5d8d9e51ce9d691.png";